/**
 * @generated SignedSource<<8d99431c1d10ef5b27ba9a3aaded73c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateProjectBillToInput = {
  billToId: string;
  clientBillToId: string;
  clientId: string;
  projectId: string;
  billFromId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateProjectBillToMutation$variables = {
  input: CreateProjectBillToInput;
};
export type CreateProjectBillToMutation$data = {
  readonly createProjectBillTo: {
    readonly projectBillTo: {
      readonly node: {
        readonly id: string;
        readonly clientId: string;
        readonly clientBillToId: string;
        readonly billTo: {
          readonly id: string;
          readonly name: string;
        } | null;
        readonly projectId: string;
        readonly billFrom: {
          readonly id: string;
          readonly name: string;
          readonly integration: string;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type CreateProjectBillToMutation = {
  variables: CreateProjectBillToMutation$variables;
  response: CreateProjectBillToMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateProjectBillToPayload",
    "kind": "LinkedField",
    "name": "createProjectBillTo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectBillToTypeEdge",
        "kind": "LinkedField",
        "name": "projectBillTo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectBillTo",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientBillToId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BillTo",
                "kind": "LinkedField",
                "name": "billTo",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BillFrom",
                "kind": "LinkedField",
                "name": "billFrom",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "integration",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateProjectBillToMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateProjectBillToMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "3c3a8dec88c67957627768d36191e25d",
    "id": null,
    "metadata": {},
    "name": "CreateProjectBillToMutation",
    "operationKind": "mutation",
    "text": "mutation CreateProjectBillToMutation(\n  $input: CreateProjectBillToInput!\n) {\n  createProjectBillTo(input: $input) {\n    projectBillTo {\n      node {\n        id\n        clientId\n        clientBillToId\n        billTo {\n          id\n          name\n        }\n        projectId\n        billFrom {\n          id\n          name\n          integration\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "10d24ecb907d89cc7a03b66bd28056e9";

export default node;
